(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hdx-black-friday-early-access"] && !Shopify.designMode) return;
  try {
    
  const earlyAccessSections = document.querySelectorAll('[data-hdx-bf-early-access]');

  earlyAccessSections.forEach((section) => {
    const target = new Date(section.getAttribute('data-target-date')).getTime();
    const days = section.querySelector('[data-hdx-bf-days]');
    const hours = section.querySelector('[data-hdx-bf-hours]');
    const minutes = section.querySelector('[data-hdx-bf-minutes]');
    const seconds = section.querySelector('[data-hdx-bf-seconds]');

    if (!target || !days || !hours || !minutes || !seconds) return;

    const pad = (value) => String(value).padStart(2, '0');
    const render = () => {
      const distance = Math.max(target - Date.now(), 0);
      const dayValue = Math.floor(distance / 86400000);
      const hourValue = Math.floor((distance % 86400000) / 3600000);
      const minuteValue = Math.floor((distance % 3600000) / 60000);
      const secondValue = Math.floor((distance % 60000) / 1000);

      days.textContent = pad(dayValue);
      hours.textContent = pad(hourValue);
      minutes.textContent = pad(minuteValue);
      seconds.textContent = pad(secondValue);
    };

    render();
    setInterval(render, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hdx-kneemax-results"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hdx-results]').forEach(function(section) {
    var track = section.querySelector('[data-hdx-results-track]');
    var previous = section.querySelector('[data-hdx-results-prev]');
    var next = section.querySelector('[data-hdx-results-next]');
    var counters = section.querySelectorAll('[data-hdx-results-count]');
    var video = section.querySelector('.hdx-kneemax-results__video');
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!track || !previous || !next) {
      return;
    }

    function scrollCards(direction) {
      var card = track.querySelector('.hdx-kneemax-results__card');
      var amount = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.85;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    previous.addEventListener('click', function() {
      scrollCards(-1);
    });

    next.addEventListener('click', function() {
      scrollCards(1);
    });

    function animateCounter(counter, index) {
      var target = parseInt(counter.getAttribute('data-hdx-results-target'), 10);

      if (!Number.isFinite(target)) {
        return;
      }

      if (prefersReducedMotion) {
        counter.textContent = target;
        return;
      }

      var duration = 900;
      var delay = index * 80;
      var start = null;

      counter.textContent = '0';

      window.setTimeout(function() {
        function step(timestamp) {
          if (!start) {
            start = timestamp;
          }

          var progress = Math.min((timestamp - start) / duration, 1);
          var eased = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
          counter.textContent = Math.round(target * eased);

          if (progress < 1) {
            window.requestAnimationFrame(step);
          } else {
            counter.textContent = target;
          }
        }

        window.requestAnimationFrame(step);
      }, delay);
    }

    function runCounters() {
      counters.forEach(function(counter, index) {
        animateCounter(counter, index);
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            runCounters();
            observer.disconnect();
          }
        });
      }, { threshold: 0.35 });

      observer.observe(section);

      if (video) {
        var videoObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              entry.target.play().catch(function() {});
            } else {
              entry.target.pause();
            }
          });
        }, { rootMargin: '200px 0px', threshold: 0.1 });

        videoObserver.observe(video);
      }
    } else {
      runCounters();
      if (video) video.play().catch(function() {});
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hdx-kneemax-use-cases"] && !Shopify.designMode) return;
  try {
    
  function hdxInitUseCases(section) {
    if (!section || section.dataset.hdxUseCasesReady === 'true') {
      return;
    }

    var track = section.querySelector('[data-hdx-use-cases-track]');
    var previous = section.querySelector('[data-hdx-use-cases-prev]');
    var next = section.querySelector('[data-hdx-use-cases-next]');
    var videos = section.querySelectorAll('.hdx-kneemax-use-cases__video');

    if (!track || !previous || !next) {
      return;
    }

    section.dataset.hdxUseCasesReady = 'true';

    var autoplayEnabled = section.dataset.hdxUseCasesAutoplay === 'true';
    var autoplayInterval = parseInt(section.dataset.hdxUseCasesInterval, 10) || 5000;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayTimer = null;
    var sectionVisible = false;
    var interactionPaused = false;

    function getStep() {
      var card = track.querySelector('.hdx-kneemax-use-cases__card');
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 0);
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    }

    function updateControls() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    function scrollCards(direction) {
      track.scrollBy({ left: getStep() * direction, behavior: 'smooth' });
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function advanceAutoplay() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;

      if (track.scrollLeft >= maxScroll) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        scrollCards(1);
      }
    }

    function startAutoplay() {
      stopAutoplay();

      if (!autoplayEnabled || reduceMotion || !sectionVisible || interactionPaused || document.hidden) {
        return;
      }

      autoplayTimer = window.setInterval(advanceAutoplay, autoplayInterval);
    }

    function pauseForInteraction() {
      interactionPaused = true;
      stopAutoplay();
    }

    function resumeAfterInteraction() {
      interactionPaused = false;
      startAutoplay();
    }

    previous.addEventListener('click', function() {
      stopAutoplay();
      scrollCards(-1);
      startAutoplay();
    });

    next.addEventListener('click', function() {
      stopAutoplay();
      scrollCards(1);
      startAutoplay();
    });

    section.addEventListener('mouseenter', pauseForInteraction);
    section.addEventListener('mouseleave', resumeAfterInteraction);
    section.addEventListener('focusin', pauseForInteraction);
    section.addEventListener('focusout', function() {
      window.setTimeout(function() {
        if (!section.contains(document.activeElement)) {
          resumeAfterInteraction();
        }
      }, 0);
    });
    track.addEventListener('pointerdown', pauseForInteraction, { passive: true });
    track.addEventListener('pointerup', resumeAfterInteraction, { passive: true });
    track.addEventListener('pointercancel', resumeAfterInteraction, { passive: true });

    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    document.addEventListener('visibilitychange', startAutoplay);
    updateControls();

    if ('IntersectionObserver' in window) {
      var autoplayObserver = new IntersectionObserver(function(entries) {
        sectionVisible = entries[0] && entries[0].isIntersecting;
        startAutoplay();
      }, { threshold: 0.35 });

      autoplayObserver.observe(section);
    } else {
      sectionVisible = true;
      startAutoplay();
    }

    if ('IntersectionObserver' in window) {
      var videoObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.play().catch(function() {});
          } else {
            entry.target.pause();
          }
        });
      }, { rootMargin: '200px 0px', threshold: 0.1 });

      videos.forEach(function(video) {
        videoObserver.observe(video);
      });
    }
  }

  document.querySelectorAll('[data-hdx-use-cases]').forEach(hdxInitUseCases);
  document.addEventListener('shopify:section:load', function(event) {
    hdxInitUseCases(event.target.querySelector('[data-hdx-use-cases]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hdx-loox-review-strip"] && !Shopify.designMode) return;
  try {
    
  function hdxInitLooxReviewStrip() {
    document.querySelectorAll('.hdx-loox-strip').forEach(function(section) {
      var track = section.querySelector('[data-hdx-loox-track]');
      var prev = section.querySelector('[data-hdx-loox-prev]');
      var next = section.querySelector('[data-hdx-loox-next]');

      if (!track || !prev || !next || track.dataset.hdxLooxReady === 'true') {
        return;
      }

      track.dataset.hdxLooxReady = 'true';

      function getStep() {
        var card = track.querySelector('.hdx-loox-strip__review');
        if (!card) {
          return track.clientWidth;
        }

        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function updateButtons() {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        prev.classList.toggle('is-disabled', track.scrollLeft <= 2);
        next.classList.toggle('is-disabled', track.scrollLeft >= maxScroll);
      }

      prev.addEventListener('click', function() {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      next.addEventListener('click', function() {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  }

  document.addEventListener('DOMContentLoaded', hdxInitLooxReviewStrip);
  document.addEventListener('shopify:section:load', hdxInitLooxReviewStrip);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hdx-recovery-system"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.hdx-system').forEach(function (root) {
    var bar = root.querySelector('[data-hdx-sticky]');
    var buy = root.querySelector('.hdx-system__purchase');
    if (!bar || !buy || !('IntersectionObserver' in window)) return;
    var buyVisible = true, endVisible = false;
    function update() {
      var show = !buyVisible && !endVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelector('[data-hdx-sticky-buy]').tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (e) { buyVisible = e[0].isIntersecting; update(); }).observe(buy);
    var end = document.querySelector('.hdx-rp-final, footer, .site-footer');
    if (end) new IntersectionObserver(function (e) { endVisible = e[0].isIntersecting; update(); }).observe(end);
    bar.querySelector('[data-hdx-sticky-buy]').addEventListener('click', function () {
      var btn = buy.querySelector('button[name="add"]');
      if (btn && !btn.disabled) btn.click();
    });
  });
})();
document.addEventListener('change', function(event) {
  if (!event.target.matches('[data-system-variant]')) return;
  var root = event.target.closest('.hdx-system');
  root.querySelectorAll('[data-system-price]').forEach(function (el) { el.textContent = event.target.selectedOptions[0].dataset.price; });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
